import { ColumnDefinition } from '@k12/tables';

/**
 * Default column definitions used by all roster types.
 * Individual roster components can extend or override these defaults.
 */
export const DEFAULT_ROSTER_COLUMN_DEFINITIONS: ColumnDefinition[] = [
  { name: 'expand', header: '', width: 1, toggleExpand: true },
  { name: 'studentDisplayId', header: 'Student ID', width: 9, sortable: true },
  { name: 'studentFirstName', header: 'Student First Name', width: 14, sortable: true },
  { name: 'studentLastName', header: 'Student Last Name', width: 14, sortable: true },
  { name: 'parentName', header: 'Parent Name', width: 18, sortable: true },
  { name: 'programAccepted', header: 'Program Accepted', width: 15, sortable: true },
  { name: 'awardTier', header: 'Opportunity Award Tier', width: 11, sortable: true },
  { name: 'esaAwardLevel', header: 'ESA+ Award Level', width: 11, sortable: true }
];

/**
 * Default displayed column names used by all roster types.
 * Individual roster components can extend or override these defaults.
 */
export const DEFAULT_ROSTER_DISPLAYED_COLUMNS: string[] = [
  'expand',
  'studentDisplayId',
  'studentFirstName',
  'studentLastName',
  'parentName',
  'programAccepted',
  'awardTier',
  'esaAwardLevel'
];

/**
 * Default mapping of column names to API field names for sorting.
 * Individual roster components can extend or override these defaults.
 */
export const DEFAULT_ROSTER_COLUMN_TO_API_FIELD_MAP: { [key: string]: string } = {
  studentDisplayId: 'studentDisplayId',
  studentFirstName: 'studentFirstName',
  studentLastName: 'studentLastName',
  parentName: 'ParentName',
  programAccepted: 'programAccepted',
  awardTier: 'awardTier',
  esaAwardLevel: 'esaAwardLevel'
};

/**
 * Column definitions for the Transfers & Withdrawals roster.
 * Extends the default columns with a Withdrawal Status column.
 */
export const TRANSFER_WITHDRAWAL_COLUMN_DEFINITIONS: ColumnDefinition[] = [
  ...DEFAULT_ROSTER_COLUMN_DEFINITIONS,
  { name: 'transferStatusId', header: 'Withdrawal Status', width: 14, sortable: true, sortKey: 'TransferStatusId' },
  { name: 'withdrawalReasonName', header: 'Withdrawal Reason', width: 14, sortable: true, sortKey: 'WithdrawalReasonId' },
  { name: 'weeksOfAttendance', header: 'Weeks Attended', width: 10, sortable: true, sortKey: 'WeeksOfAttendance' },
  { name: 'endDate', header: 'Last Day of Attendance', width: 12, sortable: true, sortKey: 'EndDate' }
];

export const TRANSFER_WITHDRAWAL_DISPLAYED_COLUMNS: string[] = [
  'expand',
  'transferStatusId',
  ...DEFAULT_ROSTER_DISPLAYED_COLUMNS.filter((columnName) => columnName !== 'expand'),
  'withdrawalReasonName',
  'weeksOfAttendance',
  'endDate'
];

export const TRANSFER_WITHDRAWAL_COLUMN_TO_API_FIELD_MAP: { [key: string]: string } = {
  ...DEFAULT_ROSTER_COLUMN_TO_API_FIELD_MAP,
  transferStatusId: 'TransferStatusId',
  withdrawalReasonName: 'WithdrawalReasonId',
  weeksOfAttendance: 'WeeksOfAttendance',
  endDate: 'EndDate'
};
